import * as styles from "./WindowHeader.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Button } from "@frontend/components/atoms/Button";
import { Icon } from "@frontend/components/atoms/Icon";

import { useWindowContext } from "./Window.context";
import type { WindowHeaderProps } from "./Window.types";

export function WindowHeader({
  className,
  children,
  actions,
  ...props
}: WindowHeaderProps): JSX.Element {
  const {
    interaction,
    maximized,
    maximizable,
    dismissible,
    startMove,
    toggleMaximize,
    close,
  } = useWindowContext();

  return (
    <div
      data-slot="window-header"
      className={clsx(
        styles.header,
        interaction === "move" && styles.headerMoving,
        className,
      )}
      onPointerDown={(event) => {
        // Buttons in the header stay clickable
        if (!(event.target as HTMLElement).closest("button, a, input")) {
          startMove(event);
        }
      }}
      onDoubleClick={(event) => {
        if (
          maximizable &&
          !(event.target as HTMLElement).closest("button, a, input")
        ) {
          toggleMaximize();
        }
      }}
      {...props}
    >
      {children}

      <div className={styles.actions}>
        {actions}

        {maximizable && (
          <Button
            variant="ghost"
            size="sm"
            aria-label={maximized ? "Restore" : "Maximize"}
            onClick={toggleMaximize}
          >
            <Icon name={maximized ? "Minimize2" : "Maximize2"} size="sm" />
          </Button>
        )}

        {dismissible && (
          <Button variant="ghost" size="sm" aria-label="Close" onClick={close}>
            <Icon name="X" size="sm" />
          </Button>
        )}
      </div>
    </div>
  );
}
